import HeroImage from "./HeroImage";
import GridGames from "./GridGames";
import GridMovies from "./GridMovies";
import { useContext } from "react";
import { UserContext } from "../Context/UserContext";

  
const Home = () => {
    const [,,,setDashboard] = useContext(UserContext)
    
    return(
        
        <div>
            {setDashboard(false)}
            <HeroImage/>
            <GridMovies/>
            <GridGames/>
        </div>
        
    )
}

export default Home